import { render, staticRenderFns } from "./AdminSettingLayout.vue?vue&type=template&id=05ade5b7"
import script from "./AdminSettingLayout.vue?vue&type=script&lang=js"
export * from "./AdminSettingLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05ade5b7')) {
      api.createRecord('05ade5b7', component.options)
    } else {
      api.reload('05ade5b7', component.options)
    }
    module.hot.accept("./AdminSettingLayout.vue?vue&type=template&id=05ade5b7", function () {
      api.rerender('05ade5b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/layout/AdminSettingLayout.vue"
export default component.exports